<template>
  <ResearchGalleryPage
    page-title="离退休干部工作"
    section-label="科研保障"
    :section-route="sectionRoute"
    :top-strip-image="topStripImage"
    :hero-background-image="heroBackgroundImage"
    :groups="groups"
  />
</template>

<script>
import ResearchGalleryPage from '@/components/ResearchGalleryPage.vue';

export default {
  name: 'LanhuLituixiuganbugongzuo',
  components: {
    ResearchGalleryPage
  },
  data() {
    return {
      sectionRoute: '/lanhu_keyanbaozhang',
      topStripImage: require('@/views/lanhu_jigouyulishi/assets/img/SketchPnge6526ecb2fcab0802b546f04824fe8f83db80e06fef6b8cf3b08d187c494f182.png'),
      heroBackgroundImage: require('@/views/lanhu_zhengwenyexueshuchengguo/assets/img/173301bb9c6d42d7ae3028c182487260_mergeImage.png'),
      groups: [
        {
          title: '主题党日与荣誉记录',
          kicker: '2000-2008',
          columns: 2,
          items: [
            {
              src: require('./assets/html/retired-2000-museum.jpg'),
              caption: '2000 年 10 月，新闻与传播研究所开展主题党日活动，党委书记孟庆海带领所离退休人员参观抗日战争纪念馆'
            },
            {
              src: require('./assets/html/retired-2001-party-day.jpg'),
              caption: '2001 年 6 月，新闻与传播研究所组织离退休党员开展主题党日活动'
            },
            {
              src: require('./assets/html/retired-certificates.jpg'),
              caption: '获奖证书照片',
              tall: true
            },
            {
              src: require('./assets/html/retired-2008-xibaipo.jpg'),
              caption: '2008 年 5 月，新闻与传播研究所党委书记庄前生带领所离退休人员赴西柏坡参观学习'
            }
          ]
        },
        {
          title: '参观考察与集体活动',
          kicker: '2008-2013',
          items: [
            {
              src: require('./assets/html/retired-2008-nangong.jpg'),
              caption: '2008 年 10 月，新闻与传播研究所组织离退休人员赴大兴南宫村秋游'
            },
            {
              src: require('./assets/html/retired-2009-museum.jpg'),
              caption: '2009 年 9 月，新闻与传播研究所离退休人员参观首都博物馆'
            },
            {
              src: require('./assets/html/retired-2012-group.jpg'),
              caption: '2012 年 5 月，新闻与传播研究所离退休老干部集体活动'
            },
            {
              src: require('./assets/html/retired-2012-huludao.jpg'),
              caption: '2012 年 8 月，新闻与传播研究所组织离退休人员赴辽宁葫芦岛考察学习'
            },
            {
              src: require('./assets/html/retired-2013-cuandixia.jpg'),
              caption: '2013 年 5 月，新闻与传播研究所组织离退休人员赴爨底下村踏青'
            }
          ]
        },
        {
          title: '慰问看望与红色教育',
          kicker: '2013-2015',
          items: [
            {
              src: require('./assets/html/retired-2013-visit.jpg'),
              caption: '2013 年 11 月，新闻与传播研究所领导看望离退休老干部'
            },
            {
              src: require('./assets/html/retired-2014-canal.jpg'),
              caption: '2014 年 5 月，新闻与传播研究所组织离退休人员游览通州大运河'
            },
            {
              src: require('./assets/html/retired-2015-spring.jpg'),
              caption: '2015 年 2 月，新闻与传播研究所领导春节前看望离退休人员'
            },
            {
              src: require('./assets/html/retired-2013-xiayunling.jpg'),
              caption: '2013 年 9 月，新闻与传播研究所开展主题党日活动，组织离退休人员赴房山区霞云岭参观《没有共产党就没有新中国》诞生地',
              wide: true
            },
            {
              src: require('./assets/html/retired-2015-langyashan.jpg'),
              caption: '2015 年 4 月，新闻与传播研究所开展主题党日活动，组织离退休人员赴河北易县追思狼牙山五勇士'
            }
          ]
        },
        {
          title: '纪念章与近年活动',
          kicker: '2015-2018',
          items: [
            {
              src: require('./assets/html/retired-2015-medal.jpg'),
              caption: '2015 年 8 月，新闻与传播研究所领导给健在的抗战老战士、老同志佩戴中国人民抗日战争胜利 70 周年纪念章',
              wide: true
            },
            {
              src: require('./assets/html/retired-2016-agri.jpg'),
              caption: '2016 年 4 月，新闻与传播研究所组织离退休人员赴昌平农业嘉年华考察'
            },
            {
              src: require('./assets/html/retired-2017-exhibition.jpg'),
              caption: '2017 年 10 月，新闻与传播研究所组织参观“砥砺奋进的五年”大型展览'
            },
            {
              src: require('./assets/html/retired-2018-garden.jpg'),
              caption: '2018 年 4 月，新闻与传播研究所组织离退休人员考察园博园'
            }
          ]
        }
      ]
    };
  }
};
</script>
